import React from 'react';
import {
  ABADefaultLayout,
  ABAUserProfileLayout
 } from 'sitecore-mm-component-library';
import { getAppDomain } from './utils/index';

/*
  APP LAYOUT
  This is where the app"s HTML structure and root placeholders should be defined.

  All routes share this root layout by default (this could be customized in RouteHandler),
  but components added to inner placeholders are route-specific.
*/

const Layout = (props) => {
  let layouts = {
    '97c6cab8-1a6c-4184-b9ab-7f432890f701': 'ABADefaultLayout',
    'b2924fe7-df79-4724-8b79-5935a9ff1a01': 'FinproUserProfileLayout',
  };
  const appEnv =   props.appEnv === null || typeof props.appEnv === 'undefined' ? 'dev' :  props.appEnv;
  const siteName = props.site.name;
  const appDomain = getAppDomain(appEnv, siteName);

  const componentProps = {
    appName: siteName,
    appDomain: appDomain,
    env: appEnv,
    pagePath: props.currentPagePath,
    pageQuery: props.pageQuery
  };
  const headTagsProps = {
    appName: siteName,
    fields: props.route.fields,
    itemId: props.route.itemId,
    pagePath: props.currentPagePath,
    pageQuery: props.pageQuery,
    env: appEnv,
    tealiumType: 'main',
    addUtagLoginCookie : true,
    utagSiteName : `MM-${siteName}`
  };
  switch (layouts[props.route.layoutId]) {
    case 'ABADefaultLayout':
      return <ABADefaultLayout {...props} route={props.route} componentProps = {componentProps} headTagsProps={headTagsProps} />;
    case 'FinproUserProfileLayout':
      return <ABAUserProfileLayout {...props} route={props.route} componentProps={componentProps} headTagsProps={headTagsProps} />;
    default:
      return null;
  }
};

export default Layout;
